import { Typography } from "@mui/material";
import React from "react";
import { HandleSkeletion } from "../../../utils/constants";
import { CustomMarkDown } from "../../chat-bot/style";
import { CommonGrid2 } from "../../common-components/StyledComponents";

export default function JobDescription({ loading, roleDataDetails, lg }) {
  return (
    <CommonGrid2>
      {loading ? (
        <HandleSkeletion height={120} />
      ) : (
        <CustomMarkDown
          fontSize={lg ? "14px" : "13px"}
          className={"scroll-job-description"}
        >
          {typeof roleDataDetails.jobDescription?.job_text === "string"
            ? roleDataDetails.jobDescription?.job_text.trim()
            : JSON.stringify(roleDataDetails.jobDescription?.job_text)}
        </CustomMarkDown>
      )}
    </CommonGrid2>
  );
}
